import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';

Vue.use(Router);
Vue.use(Meta);

import PageIndex from '@/components/pages/index/Index';
import PageAbout from '@/components/pages/about/About';
import PageWorks from '@/components/pages/works/Works';
import PageSkills from '@/components/pages/skills/Skills';
import PageContact from '@/components/pages/contact/Contact';

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'PageIndex',
      component: PageIndex
    },
    {
      path: '/about',
      name: 'PageAbout',
      component: PageAbout
    },
    {
      path: '/works',
      name: 'PageWorks',
      component: PageWorks
    },
    {
      path: '/skills',
      name: 'PageSkills',
      component: PageSkills
    },
    {
      path: '/contact',
      name: 'PageContact',
      component: PageContact
    }
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 0 }
      };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach(async (to, from, next) => {

  if(to.meta) {
    if(to.meta.beforeEnter) {
      to.meta.beforeEnter(to, from, next);
    }
    else {
      next();
    }
  } else {
    next();
  }
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js